import { makeStyles } from '@material-ui/core/styles';
import React, { Fragment, memo, useMemo } from 'react';

const styles = makeStyles(() => ({
  root: {
    color: '#28a745',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

interface IProps {
  phone: string;
}

const WhatsAppLink = memo(({ phone }: IProps) => {
  const classes = styles();

  const phoneClean = useMemo(() => {
    if (!phone) {
      return '';
    }

    if (phone.includes('***')) {
      return phone;
    }

    return phone.replace(/[^\d]/g, '');
  }, [phone]);

  const getValidNumber = useMemo(() => {
    if (phoneClean.length < 10) {
      return phoneClean;
    }

    if (phoneClean.length <= 11) {
      return `55${phoneClean}`;
    }

    return phoneClean;
  }, [phoneClean]);

  const formatPhone = useMemo(() => {
    if (phoneClean.length < 10) {
      return phoneClean;
    }

    if (phoneClean.length <= 11) {
      return `(${phoneClean.slice(0, 2)}) ${phoneClean.slice(2, phoneClean.length)}`;
    }

    return `+${phoneClean.slice(0, 2)} (${phoneClean.slice(2, 4)}) ${phoneClean.slice(4, phoneClean.length)}`;
  }, [phoneClean]);

  return phoneClean.includes('***') ? (
    <Fragment>{phoneClean}</Fragment>
  ) : (
    <a href={`https://api.whatsapp.com/send?phone=${getValidNumber}`} target='_blank' rel='noopener noreferrer' className={classes.root}>
      {formatPhone}
    </a>
  );
});

export default WhatsAppLink;
